import { fullTypeTitle, type VirtualAppointmentSummary } from './summary';

interface VirtualAppointmentTypeTitleProps {
    summary: VirtualAppointmentSummary;
    /** Classes for the code, e.g. the surrounding title weight and colour. */
    codeClassName?: string;
}

// "Vrefi · Refinement check" on one line with one ellipsis: the label truncates, the code never
// does. A custom or untitled type has no label, so its text is the part that truncates.
export function VirtualAppointmentTypeTitle({
    summary,
    codeClassName = ''
}: VirtualAppointmentTypeTitleProps) {
    const hasLabel = summary.typeLabel !== undefined;
    return (
        <span className="flex min-w-0" title={fullTypeTitle(summary)}>
            <span className={`${hasLabel ? 'shrink-0' : 'min-w-0 truncate'} ${codeClassName}`}>
                {summary.typeTitle}
            </span>
            {hasLabel && (
                <span className="min-w-0 truncate font-normal text-gray-500">
                    &nbsp;· {summary.typeLabel}
                </span>
            )}
        </span>
    );
}
